import { FormInstance } from 'antd/lib/form';

export const setInitial = (form: FormInstance) => {
  form.resetFields();
};
